module.exports = require('./dist/InfiniteScroll')



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-infinite-scroller/index.js
 ** module id = 740
 ** module chunks = 50
 **/